import React, { useState } from 'react';
import { AnimatePresence } from 'framer-motion';
import { WelcomeScreen } from './components/WelcomeScreen';
import { OnboardingScreen } from './components/OnboardingScreen';
import { MoodInputScreen } from './components/MoodInputScreen';
import { AIResponseScreen } from './components/AIResponseScreen';
import { ChatModeScreen } from './components/ChatModeScreen';
import { SettingsScreen } from './components/SettingsScreen';
import { FeedbackShareOverlay } from './components/FeedbackShareOverlay';
type Screen = 'welcome' | 'onboarding' | 'mood-input' | 'ai-response' | 'chat-mode';
export function App() {
  const [currentScreen, setCurrentScreen] = useState<Screen>('welcome');
  const [showSettings, setShowSettings] = useState(false);
  const [showFeedback, setShowFeedback] = useState(false);
  const [userMood, setUserMood] = useState('');
  const handleSkipWelcome = () => {
    setCurrentScreen('onboarding');
  };
  const handleCompleteOnboarding = () => {
    setCurrentScreen('mood-input');
  };
  const handleMoodSubmit = (mood: string) => {
    setUserMood(mood);
    setCurrentScreen('ai-response');
  };
  const handleContinueChat = () => {
    setCurrentScreen('chat-mode');
  };
  const handleFeedback = (positive: boolean) => {
    console.log('Feedback:', positive ? 'positive' : 'negative');
    setShowFeedback(true);
  };
  return <div className="min-h-screen bg-white" data-id="element-0">
      {/* Main Screens */}
      {currentScreen === 'welcome' && <WelcomeScreen onSkip={handleSkipWelcome} data-id="element-1" />}

      {currentScreen === 'onboarding' && <OnboardingScreen onComplete={handleCompleteOnboarding} data-id="element-2" />}

      {currentScreen === 'mood-input' && <MoodInputScreen onSubmit={handleMoodSubmit} onSettingsClick={() => setShowSettings(true)} data-id="element-3" />}

      {currentScreen === 'ai-response' && <AIResponseScreen mood={userMood} onContinueChat={handleContinueChat} onSettingsClick={() => setShowSettings(true)} onFeedback={handleFeedback} data-id="element-4" />}

      {currentScreen === 'chat-mode' && <ChatModeScreen initialMood={userMood} onSettingsClick={() => setShowSettings(true)} data-id="element-5" />}

      {/* Settings Overlay */}
      <AnimatePresence data-id="element-6">
        {showSettings && <SettingsScreen onClose={() => setShowSettings(false)} data-id="element-7" />}
      </AnimatePresence>

      {/* Feedback/Share Overlay */}
      <FeedbackShareOverlay isOpen={showFeedback} onClose={() => setShowFeedback(false)} data-id="element-8" />
    </div>;
}